/**
 * Image hover effect handler for images with alt-image attribute
 * Swaps to alternate image on hover and back to original on mouse leave
 * Only applies on non-mobile devices
 */
document.addEventListener('DOMContentLoaded', function() {
  // Don't apply hover effect on mobile
  const isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (isMobile) return;

  const images = document.querySelectorAll('img[alt-image]');

  images.forEach(function(img) {
    const originalSrc = img.src;
    const originalSrcset = img.srcset;
    const altImage = img.getAttribute('alt-image');

    // Generate alt srcset from alt-image URL
    const altSrcset = originalSrcset ? generateAltSrcset(altImage, originalSrcset) : '';

    img.addEventListener('mouseenter', function() {
      img.src = altImage;
      if (altSrcset) {
        img.srcset = altSrcset;
      }
    });

    img.addEventListener('mouseleave', function() {
      img.src = originalSrc;
      if (originalSrcset) {
        img.srcset = originalSrcset;
      }
    });
  });

  /**
   * Generate srcset for alternate image based on original srcset pattern
   * @param {string} altImageUrl - The alternate image URL
   * @param {string} originalSrcset - The original srcset string
   * @returns {string} Generated srcset for alternate image
   */
  function generateAltSrcset(altImageUrl, originalSrcset) {
    // Extract base URL without width parameter
    const baseUrl = altImageUrl.split('?')[0];
    const params = altImageUrl.split('?')[1] || '';

    // Extract widths from original srcset
    const widthMatches = originalSrcset.match(/width=(\d+)/g);
    if (!widthMatches) return '';

    const widths = widthMatches.map(match => match.replace('width=', ''));

    // Generate new srcset
    return widths.map(width => {
      const url = `${baseUrl}?${params.replace(/width=\d+/, `width=${width}`)}`;
      return `${url} ${width}w`;
    }).join(', ');
  }
});
